// import "./sentry_trace.js";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { Provider } from "react-redux";
import { store } from "./store.js";
import { BrowserRouter } from "react-router-dom";
import Error from "./views/components/ErrorComponent/ErrorComponent.jsx";
import { Toaster } from "../components/ui/sonner.jsx";


const signature = window.location.search?.split("?signature=")?.[1] || "";

if (signature) {
    ReactDOM.createRoot(document.getElementById("root")).render(
        <BrowserRouter>
                <Provider store={store}>
                    <App/>
                    <Toaster position="top-right" closeButton />
                </Provider>
        </BrowserRouter>
    );
} else {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <BrowserRouter>
        <Provider store={store}>
              <Error/>
        </Provider>
    </BrowserRouter>
  );
}

if (import.meta.hot) {
  import.meta.hot.accept("./App", () => {
    return require("./App").default;
  });
}
